import { render, staticRenderFns } from "./ContentProductsMobile.vue?vue&type=template&id=932f1ffe&scoped=true&"
import script from "./ContentProductsMobile.vue?vue&type=script&lang=js&"
export * from "./ContentProductsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ContentProductsMobile.vue?vue&type=style&index=0&id=932f1ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932f1ffe",
  null
  
)

export default component.exports